import { render, staticRenderFns } from "./PeriodInfoIframe.vue?vue&type=template&id=381a040b&"
import script from "./PeriodInfoIframe.vue?vue&type=script&lang=ts&"
export * from "./PeriodInfoIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports